import { Component, OnInit, Input } from '@angular/core';
import { LoanApplication, ApplicationAccessSpecifier } from '@app/applications/applications.model';
import { FormControl, FormGroup, FormArray } from '@angular/forms';
import { ApplicationService } from '@app/applications/application.service';
import { MatSnackBar } from '@angular/material';
import { DateFormatPipe } from '@app/utils/date-format.pipe';
import { IgFileService, Files } from '@ig-core/form/igFile.service';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImagePreviewDialogService } from '@app/utils/image-preview-dialog/image-preview-dialog.service';
import { ApplicationQuestionnaire, Questionnaire } from '../cam.model';
import { File, Folder, FolderFilesComposite } from '../../loanInformation/loan-folder-files/loan-folder-files.model';
import * as fileSaver from 'file-saver';
import { FileUploadService } from '@app/utils/file-upload/file-upload.service';
import { ConfirmationDialogService } from '@app/utils/confirmation-dialog/confirmation-dialog.service';
import { SecureStorageService } from '@ig-core/authentication/secureStorage.service';
import { CAM_GEOLOCATION_EDIT } from '@app/constants/data.constants';
import { ControlValidators } from '@app/applications/application-validators/control-validators.directive';
import { ValidationService } from '@app/applications/application-validators/validation.service';

@Component({
  selector: 'eng-question-answer-system',
  templateUrl: './question-answer-system.template.html',
  styleUrls: ['../../application-details.styles.scss', './question-answer-system.style.scss']
})
export class QuestionAnswerSystemComponent implements OnInit {
  
  @Input() application: LoanApplication;
  
  @Input() questionnaireCode: string;
  
  @Input() menuCode: string;

  QandAForm: FormGroup

  applicationQuestionByQID: Questionnaire & ApplicationQuestionnaire;
  applicationQuestion: ApplicationQuestionnaire = null;
  allQuestionForCode: Questionnaire;

  prefilledDataSet: any = {}

  allowAccess: Boolean;
  menuItemAllowAccess: boolean;

  applicationAccessSpecifiers: ApplicationAccessSpecifier[];
  menuItemAccessSpecifier: ApplicationAccessSpecifier;
  loginUser: any;
  allFilesInFolder: FolderFilesComposite;

  constructor(private applicationService: ApplicationService, private fileService: IgFileService, private imagePreviewDialogService: ImagePreviewDialogService,
    private _snackbar: MatSnackBar, private customDatepipe: DateFormatPipe, private domSanitizer: DomSanitizer,
    private fileUploadService: FileUploadService, private confirmationDialogService: ConfirmationDialogService,
    private secureStorageService: SecureStorageService,
    private validationService: ValidationService) {
    this.allowAccess = this.applicationService.allowAccess;
  }


  ngOnInit() {
    this.loginUser = this.secureStorageService.secureSessionStorage.getItem("logInUserDetails")
    this.QandAForm = new FormGroup({
      latitude: new FormControl(''),
      longitude: new FormControl(''),
      questionnaireResponseDetail: new FormArray([])
    })
    this.QandAForm.disable()
    this.getQandAbyQuestionnaireCode()
    this.getApplicationQandAbyQuestionnaireCode()
    this.getQuestionPrefilledData()
    this.getMenuItemAccess();

  }


  //"CAMCMQ"
  //"BCPVQ"
  //"RCPVQ"
  getQandAbyQuestionnaireCode() {
    this.applicationService.getquestionnairebyCode(this.questionnaireCode).subscribe(response => {
      this.allQuestionForCode = response.body[0]
    
     if( this.applicationQuestionByQID == undefined){
      console.log("IN getQandAbyQuestionnaireCode" ,this.applicationQuestionByQID)
      this.applicationQuestionByQID = response.body[0]
      this.parseQuestionConfiguration()
      this.buildQandAForm()
      }
    })
  }


  //this function will get a application question's for particular questionnaire code
  getApplicationQandAbyQuestionnaireCode() {
    this.applicationService.getApplicationQuestionnairebyCode(this.application.uid, this.questionnaireCode).subscribe(response => {
      this.applicationQuestionByQID = response.body
      this.applicationQuestion = response.body
      console.log("IN getApplicationQandAbyQuestionnaireCode" ,this.applicationQuestionByQID)
      if (response.body == null) {
        this.applicationQuestionByQID = this.allQuestionForCode as any
      } else {
        this.parseQuestionConfiguration()
      this.buildQandAForm()       
    }
    });
  }


  buildQandAForm() {
    this.QandAForm.patchValue({
        latitude: this.applicationQuestionByQID.latitude || null,
        longitude: this.applicationQuestionByQID.longitude || null
    })  
    const array = new FormArray([]);
    this.applicationQuestionByQID.questions.forEach((element) => {
      const group = new FormGroup({
        answer: new FormControl(element.questionnaireResponseDetail !== null ? element.questionnaireResponseDetail.answer : ''),
        questionUid: new FormControl(element.questionnaireResponseDetail !== null ? element.questionnaireResponseDetail.questionUid : ""),
      })
      array.push(group);
    });
    this.QandAForm.setControl('questionnaireResponseDetail',array);

    this.QandAForm.controls['latitude'].setValidators([
      ControlValidators.patternValidator('-?[0-9]+(\\.[0-9]+)?', 'Latitude should be a valid number'),
      ControlValidators.numericRangeValidator(-90, 90, true, true, 'Latitude should be in the range -90 to 90')]);
    this.QandAForm.controls['latitude'].updateValueAndValidity();

    this.QandAForm.controls['longitude'].setValidators([
      ControlValidators.patternValidator('-?[0-9]+(\\.[0-9]+)?', 'Longitude should be a valid number'),
      ControlValidators.numericRangeValidator(-180, 180, true, true, 'Longitude should be in the range -180 to 180')]);
    this.QandAForm.controls['longitude'].updateValueAndValidity();

    this.QandAForm.disable()
    this.getSelectedFolderFiles(this.applicationQuestionByQID.fileFolderUid)
  }


  enableDisableForm() {
    this.QandAForm.enable()
    // right now geolocation is captured in mobile app. If required then we are enabling in web app based on authority
    const canGeolocationEdit = this.loginUser.authorities.includes(CAM_GEOLOCATION_EDIT);
    if (!canGeolocationEdit) {
      this.QandAForm.controls.latitude.disable()
      this.QandAForm.controls.longitude.disable()
    }
  }


  saveQuestionAndAnswer() {
    this.validationService.markFormGroupTouched(this.QandAForm)
    if(this.QandAForm.enabled && this.QandAForm.valid){
    let todaydate = new Date();
    this.setQuestionId()
    this.stringfyTheMultimediaFileNameIdMapString(this.applicationQuestionByQID)
    this.applicationQuestionByQID["applicationUid"] = this.application.uid
    this.applicationQuestionByQID["questionnaireUid"] = this.applicationQuestionByQID.questionnaireUid === undefined ? this.applicationQuestionByQID.uid : this.applicationQuestionByQID.questionnaireUid
    this.applicationQuestionByQID["endTime"] = this.customDatepipe.transform(todaydate, 'CAMDATE');
    if (this.applicationQuestion == null) {
      this.applicationQuestionByQID["startTime"] = this.customDatepipe.transform(todaydate, 'CAMDATE');
      delete this.applicationQuestionByQID.uid
      delete this.applicationQuestionByQID.name
      delete this.applicationQuestionByQID.version
      delete this.applicationQuestionByQID.description
      delete this.applicationQuestionByQID.questionnaireVersionCode
      delete this.applicationQuestionByQID.questionnaireVersionName
      delete this.applicationQuestionByQID.status
      delete this.applicationQuestionByQID.code
    }
    delete this.applicationQuestionByQID.startTime
    delete this.applicationQuestionByQID.questions
    this.applicationQuestionByQID.latitude = this.QandAForm.getRawValue().latitude;
    this.applicationQuestionByQID.longitude = this.QandAForm.getRawValue().longitude;
    this.applicationService.saveApplicationquestionnaireAnswers(this.applicationQuestionByQID).toPromise().then(
      (_success) => {
        this._snackbar.open("Answers are updated successfully", "Close", {
          duration: 2000,
        });
        this.getApplicationQandAbyQuestionnaireCode()
      }, (failure) => {
        let errormesg =[]
        errormesg.push("Answers update failed")
        errormesg.push(failure)
        this.applicationService.displayErrorMessages(errormesg);
        console.log(failure);
      }
    );
  }
  }


  cancelForm() {
    // this.QandAForm.controls.questionnaireResponseDetail = new FormArray([])
    this.QandAForm.disable();
    this.buildQandAForm()
  }


  parseQuestionConfiguration() {
    if (this.applicationQuestionByQID.questions) {
      this.applicationQuestionByQID.questions.forEach((element, index) => {
        element.configuration = JSON.parse(element.configuration)
        if (element.questionnaireResponseDetail && element.questionnaireResponseDetail.multiMediaFileNameIdMapString != null) {
          // element.questionnaireResponseDetail.multiMediaFileNameIdMapString = element.questionnaireResponseDetail.multiMediaFileNameIdMapString.replace(/=/g, ":");
          element.questionnaireResponseDetail.multiMediaFileNameIdMapString = JSON.parse(element.questionnaireResponseDetail.multiMediaFileNameIdMapString)
          element.questionnaireResponseDetail["imageFiles"] = []
          this.getMultiMediaFiles(element.questionnaireResponseDetail.multiMediaFileNameIdMapString, index)
        }

      });
    }
  }


  //this function will call while saving a response
  //answers array will be generated based on save or update for a particular question
  //if a question exists "questionnaireResponseDetail" the complete question object will pushed to answers array
  // if a question does not exists "questionnaireResponseDetail" the answer and questionUid set with values will be pushed to answers array
  setQuestionId() {
    this.applicationQuestionByQID.answers = (this.applicationQuestionByQID.answers == null || this.applicationQuestionByQID.answers == undefined) ? [] : this.applicationQuestionByQID.answers
    this.applicationQuestionByQID.questions.forEach((element, index) => {
      const formgroup = this.QandAForm.get("questionnaireResponseDetail")['controls'][index]
      if (element.questionnaireResponseDetail !== null) {
        let newObject = element.questionnaireResponseDetail
        newObject.answer = formgroup.controls.answer.value
        this.applicationQuestionByQID.answers.push(newObject)
      } else {
        this.applicationQuestionByQID.answers.push({ "answer": formgroup.controls.answer.value, "questionUid": element.uid })
      }
    });
  }

  //this function will get prefilled CAM Data
  getQuestionPrefilledData() {
    this.applicationService.getQuestionPrefilledDataforApplication(this.application.uid).subscribe(response => {
      this.prefilledDataSet = response.body
    })
  }


  getMultiMediaFiles(files, index) {
    const images = [];
  //  console.log("files", files)
    for (var propName in files) {
      let imagedata = {}
      this.fileService.fileStreamById(files[propName],
        "true").subscribe(image => {
          let reader = new FileReader();
          reader.addEventListener("load", () => {
            let result = reader.result as string
            let fileContent = this.domSanitizer.bypassSecurityTrustUrl(result) as SafeUrl;
            imagedata = { "imageLoaded": true, "fileContent": fileContent };
            this.applicationQuestionByQID.questions[index].questionnaireResponseDetail.imageFiles.push(imagedata)
          }, false);
          if (image) reader.readAsDataURL(image.data);
        });
    }
  }

  //this function is called on clicking of question images's
  // this will open up a image viewer dialog box
  openImageViewer(fileNameAndFileId) {
    let files = new FolderFilesComposite(new Folder());
    // The 'fileNameAndFileId' object contains key-value pairs where:
    // key fileName and value is FileId (e.g: image_abc.jpeg: "4fc22cc")
    // for imagePreviewService we need to send in FolderFilesComposite format hence we are converting it.
    files.fileInfo = Object.keys(fileNameAndFileId).map(fileName => ({
      fileId: fileNameAndFileId[fileName], // Retrieve the file ID using the file name as the key
      type: "image/*" // Set the file type as an image this is required in imagePreviewService
    }));

    this.imagePreviewDialogService.open({ "images": files })
  }
  //this function will get either this menu item  is editable or readonly 
  getMenuItemAccess() {
    this.applicationService.getApplicationAccessModifiers(this.application.uid)
      .subscribe((response) => {
        this.applicationAccessSpecifiers = response.body;
        this.menuItemAccessSpecifier = this.applicationAccessSpecifiers
          .find(accessSpecifier => accessSpecifier.category === this.menuCode);
        if (this.menuItemAccessSpecifier) {
          this.menuItemAllowAccess = this.menuItemAccessSpecifier.allowAccess;
        }
      });
  }

  //this function is called before saving answers
  //to format the "multiMediaFileNameIdMapString" parameter to string
  //api will accept this "multiMediaFileNameIdMapString" parameter if datatype is string
  stringfyTheMultimediaFileNameIdMapString(data) {
    this.applicationQuestionByQID.questions.forEach((element, index) => {
      if(element.questionnaireResponseDetail){
      if (element.questionnaireResponseDetail["imageFiles"]) {
        delete element.questionnaireResponseDetail.imageFiles
      }
      element.questionnaireResponseDetail.multiMediaFileNameIdMapString = JSON.stringify(element.questionnaireResponseDetail.multiMediaFileNameIdMapString)
    }
     
    })
  
  }
  getSelectedFolderFiles(folderUid) {
    if (folderUid) {
      this.applicationService.getAllFilesInApplicationFolder(this.application.uid, folderUid).subscribe((response: any) => {
        if (response) {
          this.allFilesInFolder = response.body;
          this.allFilesInFolder.fileInfo.forEach(element => {
            if (element.fileSize) {
              element["convertedFileSize"] = this.applicationService.bytesToSize(element.fileSize)
            }
          });
        }
      }, error => {
        this.allFilesInFolder = {
          folderInfo: {},
          fileInfo: []
        }
      });
    }
  }

  openImagePreviewDialog() {
    this.imagePreviewDialogService.open({ "images": this.allFilesInFolder })
  }

  openImageFileUploadDialog() {
    if (this.applicationQuestionByQID.fileFolderUid) {
      this.fileUploadService.open({ "uploadType": "multiple", "folderUid": this.applicationQuestionByQID.fileFolderUid, "applicationUid": this.application.uid, "files": this.allFilesInFolder.fileInfo })
      this.fileUploadService.confirmed().subscribe(data => {
        this.getSelectedFolderFiles(data.folderUid)
      })

    } else {
      this._snackbar.open("Please add a folder to upload files", "Close", {
        duration: 5000,
      });
    }
  }

  downloadFile(file) {
    this.applicationService.downloadFileFromApplicationFolder(this.application.uid, file.folderUid, file.fileId).subscribe(image => {
      const blob = new Blob([image.data], { type: file.type });
      fileSaver.saveAs(blob, file.fileName);
      this._snackbar.open("File has been downloaded successfully", "Close", {
        duration: 5000,
      });
    })
  }

  openfileDeleteConfirmation(selectedFile) {
    this.confirmationDialogService.open({ "btnCancelText": "Cancel", "btnConfirmText": "Delete", "message": "Are you sure you want to delete this File?" })
    this.confirmationDialogService.confirmed().subscribe(data => {
      if (data) {
        this.deleteFile(selectedFile)
      }
    })
  }

  deleteFile(selectedFile) {
    this.applicationService.fileDelete(this.application.uid, selectedFile.uid).subscribe((response) => {
      if (response.body.status == "success") {
        this._snackbar.open("File deleted successfully", "Close", {
          duration: 2000,
        });
        this.getSelectedFolderFiles(this.applicationQuestionByQID.fileFolderUid);
      } else {
        let errormesg = []
        errormesg.push("File deleted failed")
        errormesg.push(response.body.message)
        this.applicationService.displayErrorMessages(errormesg);
      }
    }, (failure) => {
      let errormesg = []
      errormesg.push("File deleted failed")
      errormesg.push(failure)
      this.applicationService.displayErrorMessages(errormesg);
    });
  }

  viewPdf(file) {
    this.fileService.fileStreamById(file.fileId, "false").subscribe(res => {
      window.open(res.data, '_blank');
    })
  }

  openGoogleMaps() {
    const lat = this.QandAForm.getRawValue().latitude;
    const lng = this.QandAForm.getRawValue().longitude;
    
    window.open(`https://www.google.com/maps?q=${lat},${lng}`,'_blank');
  }

  limitDecimalPlaces(controlName: string, event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    const parts = value.split('.');

    // If there are more than 6 decimal places, limiting it to 6
    if (parts.length > 1 && parts[1].length > 6) {
      const limitedValue = parts[0] + '.' + parts[1].substring(0, 6);

      input.value = limitedValue;
      this.QandAForm.get(controlName).setValue(limitedValue);
    }
  }
}